import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
    createEvent, getMyEvent, getPastEvents,getInterestedEvent, getGoingEvent, getInvitedEvent, getSuggestedEvent, removeEventInvitation, searchEvent, getEventCategory, deleteEvent
} from "./eventAction";
import apiInstance from "../../config/api";

export const addContentToExistingEvent = (incomingContent, existingArray) => {
    incomingContent.forEach((item) => {

        const existingIndex = existingArray.findIndex((existingItem) =>
            existingItem.eventId === item.eventId
        );

        if (existingIndex !== -1) {
            existingArray[existingIndex] = item;
        } else {
            existingArray.push(item);
        }
    });
};

const getEventDetails = async (eventId) => {
    try {
        const request = await apiInstance.get(`/api/events/${eventId}`)
        const response = request.data
        if (response.status === 'success') {
            return response.event
        } else {
            throw new Error(response.message)
        }
    }
    catch (error) {
        throw new Error(error.message)
    }
}

export const fetchEventProfile = createAsyncThunk('event/profile', async (eventId, { dispatch }) => {
    try {
        // console.log('hello')
        const eventDetails = await getEventDetails(eventId)
        dispatch(updateEventInfo(eventDetails))

        return { ...eventDetails }
    }
    catch (error) {
        throw new Error(error.message)
    }
})

const initialState = {
    loading: false,
    creating: false,
    profiles: {},

    loadingCategory: false,
    eventCategory: {},
    categoryError: null,

    suggesedEventLoading: false,
    suggestedEvent: [],

    myEventLoading: false,
    myEvent: [],

    interestedEventLoading: false,
    interestedEvent: [],

    goinEventLoading: false,
    goingEvent: [],

    invitationLoading: false,
    invitaionEvents: [],

    searchQuerry: '',
    searching: false,
    eventSearchHistory: [],
    searchError: '',

    pastEventLoading: false,
    pastEvent: [],

    error: null
}

const eventSlice = createSlice({
    name: 'event',
    initialState,
    reducers: {
        updateEventInfo(state, action) {
            const eventDetails = action.payload
            state.profiles[eventDetails.eventId] = { ...state.profiles[eventDetails.eventId], ...eventDetails }
        },
        updateInterestedEvent(state, action) {
            const { method, data } = action.payload
            const index = state.suggestedEvent.findIndex(event => event.eventId === data.eventId)

            if (method === 'add') {
                state.interestedEvent.push(data)

                if (state.profiles[data.eventId]) {
                    state.profiles[data.eventId].interestedStatus = true
                    state.profiles[data.eventId].numInterested = (state.profiles[data.eventId].numInterested || 0) + 1
                }

                if (index !== -1) {
                    state.suggestedEvent[index].interestedStatus = true
                    state.suggestedEvent[index].numInterested = (state.suggestedEvent[index].numInterested || 0) + 1
                }

            }
            else {
                if (index !== -1) {
                    state.suggestedEvent[index].interestedStatus = false
                    state.suggestedEvent[index].numInterested = Math.max((state.suggestedEvent[index].numInterested || 0) - 1, 0)
                }

                if (state.profiles[data.eventId]) {
                    state.profiles[data.eventId].interestedStatus = false
                    state.profiles[data.eventId].numInterested = Math.max((state.profiles[data.eventId].numInterested || 0) - 1, 0)
                }

                const filteredEvents = state.interestedEvent.filter(event => event.eventId !== data.eventId)
                state.interestedEvent = filteredEvents
            }
        },
        updateGoingEvent(state, action) {
            const { method, data } = action.payload

            if (method === 'add') {

                if (state.profiles[data.eventId]) {
                    state.profiles[data.eventId].goingStatus = true
                    state.profiles[data.eventId].numGoing = (state.profiles[data.eventId].numGoing || 0) + 1
                }

                state.goingEvent.push(data)
            }
            else {

                if (state.profiles[data.eventId]) {
                    state.profiles[data.eventId].goingStatus = false
                    state.profiles[data.eventId].numGoing = Math.max((state.profiles[data.eventId].numGoing || 0) - 1, 0)
                }

                const filteredEvents = state.goingEvent.filter(event => event.eventId !== data.eventId)
                state.goingEvent = filteredEvents
            }
        },
        updateSearchQuerry(state, action) {
            state.searchQuerry = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEventProfile.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchEventProfile.fulfilled, (state, action) => {
                state.loading = false
                state.profiles[action.payload.eventId] = action.payload
            })
            .addCase(fetchEventProfile.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

        builder
            .addCase(createEvent.pending, (state) => {
                state.creating = true
            })
            .addCase(createEvent.fulfilled, (state, action) => {
                state.creating = false
                state.myEvent.push(action.payload)
            })
            .addCase(createEvent.rejected, (state, action) => {
                state.creating = false
                state.error = action.error.message
            })

        builder
            .addCase(getSuggestedEvent.pending, (state) => {
                state.suggesedEventLoading = true
            })
            .addCase(getSuggestedEvent.fulfilled, (state, action) => {
                state.suggesedEventLoading = false
                state.suggestedEvent = action.payload
            })
            .addCase(getSuggestedEvent.rejected, (state, action) => {
                state.suggesedEventLoading = false
                state.error = action.error.message
            })

        builder
            .addCase(getMyEvent.pending, (state) => {
                state.myEventLoading = true
            })
            .addCase(getMyEvent.fulfilled, (state, action) => {
                state.myEventLoading = false
                state.myEvent = action.payload
            })
            .addCase(getMyEvent.rejected, (state, action) => {
                state.myEventLoading = false
                state.error = action.error.message
            })

        builder
            .addCase(getInterestedEvent.pending, (state) => {
                state.interestedEventLoading = true
            })
            .addCase(getInterestedEvent.fulfilled, (state, action) => {
                state.interestedEventLoading = false
                state.interestedEvent = action.payload
            })
            .addCase(getInterestedEvent.rejected, (state, action) => {
                state.interestedEventLoading = false
                state.error = action.error.message
            })

        builder
            .addCase(getGoingEvent.pending, (state) => {
                state.goinEventLoading = true
            })
            .addCase(getGoingEvent.fulfilled, (state, action) => {
                state.goinEventLoading = false
                state.goingEvent = action.payload
            })
            .addCase(getGoingEvent.rejected, (state, action) => {
                state.goinEventLoading = false
                state.error = action.error.message
            })

        builder
            .addCase(getInvitedEvent.pending, (state) => {
                state.invitationLoading = true
            })
            .addCase(getInvitedEvent.fulfilled, (state, action) => {
                state.invitationLoading = false
                state.invitaionEvents = action.payload
            })
            .addCase(getInvitedEvent.rejected, (state, action) => {
                state.invitationLoading = false
                state.error = action.error.message
            })

        builder
            .addCase(removeEventInvitation.fulfilled, (state, action) => {
                const { message, invitationId } = action.payload
                const filterInvite = state.invitaionEvents.filter(invitation => invitation.invitationId !== invitationId)
                if (message === 'Invitation removed successfully') {
                    state.invitaionEvents = filterInvite
                }
            })

        builder
            .addCase(searchEvent.pending, (state) => {
                state.searching = true
            })
            .addCase(searchEvent.fulfilled, (state, action) => {
                state.searching = false
                addContentToExistingEvent(action.payload, state.eventSearchHistory)
            })
            .addCase(searchEvent.rejected, (state, action) => {
                state.searchError = action.error.message
            })

        builder
            .addCase(getEventCategory.pending, (state) => {
                state.loadingCategory = true
            })
            .addCase(getEventCategory.fulfilled, (state, action) => {
                state.loadingCategory = false
                const { category, data } = action.payload
                state.eventCategory[category] = data
            })
            .addCase(getEventCategory.rejected, (state, action) => {
                state.loadingCategory = false
                state.categoryError = action.error.message
            })



        builder
            .addCase(getPastEvents.pending, (state) => {
                state.pastEventLoading = true;
                state.pastEventError = null;
            })
            .addCase(getPastEvents.fulfilled, (state, action) => {
                state.pastEventLoading = false;
                state.pastEvent = action.payload;
            })
            .addCase(getPastEvents.rejected, (state, action) => {
                state.pastEventLoading = false;
                state.pastEventError = action.error.message;
            });
        // Add this after the existing builder cases, before the closing of extraReducers

        builder
            .addCase(deleteEvent.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteEvent.fulfilled, (state, action) => {
                state.loading = false;
                const { eventId } = action.payload;

                // Remove from profiles object
                delete state.profiles[eventId];

                // Remove from myEvent array (events user created)
                state.myEvent = state.myEvent.filter(event => event.eventId !== eventId);

                // Optionally remove from other lists (suggested, going, interested, invitations)
                state.suggestedEvent = state.suggestedEvent.filter(event => event.eventId !== eventId);
                state.goingEvent = state.goingEvent.filter(event => event.eventId !== eventId);
                state.interestedEvent = state.interestedEvent.filter(event => event.eventId !== eventId);
                state.invitaionEvents = state.invitaionEvents.filter(inv => inv.event?.eventId !== eventId);

                // Success message can be handled in component
            })
            .addCase(deleteEvent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }


})

export const { updateEventInfo, updateGoingEvent, updateInterestedEvent, updateSearchQuerry } = eventSlice.actions
export default eventSlice.reducer;